import {
  createStyles,
  Divider,
  Group,
  Stack,
  Text,
  Tooltip,
} from '@mantine/core';
import React from 'react';

import { useDesign } from '@portals/api/organizations';
import { useOpenRouteModal } from '@portals/framework/route-modals';
import { useIsSidebarOpen } from '@portals/redux';
import { DesignType } from '@portals/types';

import { ReactComponent as Connect } from '../../../assets/img/icons/connect.svg';

export const ConnectToggle = () => {
  const isSidebarOpen = useIsSidebarOpen();
  const design = useDesign();
  const { cx, classes } = useStyles({ design });
  const openRouteModal = useOpenRouteModal();

  return (
    <Stack className={classes.container} spacing={0}>
      <Divider className={classes.divider} />

      <Tooltip
        label={<Text size="xs">Connect +</Text>}
        position="right"
        disabled={isSidebarOpen}
        withinPortal
      >
        <Group
          className={cx(classes.item, { open: isSidebarOpen })}
          onClick={() => openRouteModal({ modalId: 'connect' })}
        >
          <Connect />

          {isSidebarOpen ? <span>Connect +</span> : null}
        </Group>
      </Tooltip>
    </Stack>
  );
};

const useStyles = createStyles(
  (theme, { design }: { design?: DesignType }) => ({
    container: {
      padding: `0 ${theme.spacing.md}`,
    },
    divider: {
      borderColor: theme.colors.blue_gray[0],
      margin: `${theme.spacing.lg} 0`,
    },
    item: {
      height: 44,
      padding: `10px ${theme.spacing.md}`,
      borderRadius: theme.spacing.sm,
      transition: 'all 0.15s ease-in-out',
      cursor: 'pointer',
      color:
        design?.navigation_menu?.menu_text_color || theme.colors.blue_gray[6],

      svg: {
        flexShrink: 0,
      },

      '&:not(.open)': {
        display: 'flex',
        justifyContent: 'center',
      },

      ':hover': {
        color:
          design?.navigation_menu?.hovered_section_text_color ||
          theme.colors.blue_gray[6],
        backgroundColor:
          design?.navigation_menu?.hovered_section_background_color ||
          theme.colors.gray[1],
      },
    },
  })
);
